<template>
  <div>
    <!-- 出入金变更 -->
    <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.depositWithdrawalModification')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <el-tab-pane :label="`${item.status_name}(${item.count})`" :name="item.status + ''"
            v-for="(item, index) in tab" :key="index"> </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="item"><el-input v-model="datas.keywords" placeholder="客户ID/客户名" clearable></el-input></div>
        <!--搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        <!-- 申请出入金变更 -->
        <div class="applyForDepositWithdrawalModification">
          <el-button type="success" @click="applyForDepositWithdrawalModification" v-if="isAuth(655)">{{
            $t('message.applyForDepositWithdrawalModification')
          }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 登记时间 -->
          <li>{{ $t('message.registrationTime') }}</li>
          <!-- 客户 -->
          <li>{{ $t('message.user') }}</li>
          <!-- 申请人 -->
          <li>{{ $t('message.theApplicant') }}</li>
          <!-- 申请原因 -->
          <li class="flex2">{{ $t('message.reasonForApplication') }}</li>
          <!-- 附带图片 -->
          <li class="flex2">{{ $t('message.withAttachedImages') }}</li>
          <!-- 出入金明细. 円 -->
          <li class="flex2">{{ $t('message.entryAndExitDetails') }}. 円</li>
          <!-- 出入金名义（客户看） -->
          <li class="flex2">{{ $t('message.depositWithdrawalName') }}（客户看）</li>
          <!-- 审核备注 -->
          <li class="flex2">{{ $t('message.auditRemarks') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 审核时间 -->
          <li>{{ $t('message.reviewTime') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 登记时间 -->
          <li>{{ item.created_at }}</li>
          <!-- 客户 -->
          <li>
            <div class="template">
              <p>{{ item.user.realname }}</p>
              <p>ID:{{ item.user.id }}</p>
            </div>
          </li>
          <!-- 申请人 -->
          <li>{{ item.created_by_admin.realname }}</li>
          <!-- 申请原因 -->
          <li class="flex2">{{ item.adjust_reason }}</li>
          <!-- 附带图片 -->
          <li class="flex2">
            <div class="image">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="image" :preview-src-list="[image]"
                v-for="(image, imggeIndex) in item.image" :key="imggeIndex">
              </el-image>
            </div>
          </li>
          <!-- 出入金明细. 円 -->
          <li class="flex2">
            <div class="template">
              <!-- 出入金类型 -->
              <p>{{ $t('message.depositWithdrawalType') }}：{{ item.type_name }}
              </p>
              <!-- 变更金额 -->
              <p>{{ $t('message.modifiedAmount') }}:{{ item.amount }}</p>
            </div>
          </li>
          <!-- 出入金名义（客户看） -->
          <li class="flex2">{{ item.client_bill_reason }}</li>
          <!-- 审核备注 -->
          <li class="flex2">{{ item.confirm_remark }}</li>
          <!-- 状态 -->
          <li>{{ item.status_name }}</li>
          <!-- 审核时间 -->
          <li>{{ item.reviewed_at }}</li>
          <!-- 操作 -->
          <li>
            <div class="template" v-if="item.status == 0">
              <!-- 确认 -->
              <p><el-button type="primary" size="mini" class="primary"
                  @click="reviewApply(item, $t('message.notarize'), true)" v-if="isAuth(657)">
                  {{ $t('message.notarize') }}</el-button>
              </p>
              <!-- 拒绝 -->
              <p><el-button type="danger" size="mini" @click="reviewApply(item, $t('message.reject'), false)"
                  v-if="isAuth(656)">
                  {{ $t('message.reject') }}</el-button>
              </p>
              <!-- 取消申请 -->
              <p><el-button type="danger" size="mini" class="dark" @click="adjustApplicationCancel(item)">
                  {{ $t('message.cancellationRequest') }}</el-button>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 取消申请 -->
    <cancellationRequest ref="cancellationRequest" />
    <!-- 申请出入金变更 -->
    <applyForDepositWithdrawalModification ref="applyForDepositWithdrawalModification" />
    <!--  审核-->
    <review ref="review" />
  </div>
</template>
<script>
import cancellationRequest from './components/cancellationRequest'
import applyForDepositWithdrawalModification from './components/applyForDepositWithdrawalModification'
import review from './components/review'
export default {
  components: {
    cancellationRequest,
    applyForDepositWithdrawalModification,
    review
  },
  data() {
    return {
      tab: [],
      datas: {
        keywords: '',
        status: '0',
        page: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: []
    };
  },
  created() {
    this.adjustApplicationListTab()
    this.adjustApplicationList()
  },
  methods: {
    // 列表tab统计
    adjustApplicationListTab() {
      this.$api.financialApi.adjustApplicationListTab().then(res => {
        this.tab = res.data
      })
    },
    // 列表
    adjustApplicationList() {
      this.$api.financialApi.adjustApplicationList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(this.tableData);
      })
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.adjustApplicationList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.adjustApplicationList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.adjustApplicationList();
    },
    // 申请出入变更
    applyForDepositWithdrawalModification() {
      this.$refs.applyForDepositWithdrawalModification.dialogVisible = true
      this.$refs.applyForDepositWithdrawalModification.name = ''
      this.$refs.applyForDepositWithdrawalModification.image = []
      this.$refs.applyForDepositWithdrawalModification.ruleForm = {
        user_id: '',
        adjust_reason: '',
        type: '',
        amount: '',
        client_bill_reason: '',
        image: [],
      }
    },
    //取消申请
    adjustApplicationCancel(item) {
      this.$refs.cancellationRequest.datas = item
      this.$refs.cancellationRequest.dialogVisible = true
    },
    //审核申请
    reviewApply(item, title, flag) {
      this.$refs.review.isNotarize = flag
      this.$refs.review.title = title
      this.$refs.review.confirm_remark = ''
      this.$refs.review.datas = item
      this.$refs.review.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;
  margin: 0 0px 24px;

  .applyForDepositWithdrawalModification {
    position: absolute;
    top: 0;
    right: 0;
  }

  .item {
    width: 300px;
    margin-right: 24px;
  }
}

.table {
  position: relative;

  ol {
    height: 60px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
  }

  ul {
    background-color: #fff;
    padding: 20px 0;
    text-align: center;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    p {
      margin-bottom: 10px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}
</style>